import { PageHeader } from "@ant-design/pro-components";
import { observer } from 'mobx-react';
import React from "react";
import '../common/page-header.css';
import NewTaskPanel from "./new-task-panel";
import Subjects from "../../models/subjects";

const TaskAdd: React.FC<{subject: Subjects}> = ({subject}) => {

    return (
        <div className="content">
            <PageHeader title="Добавление задачи" className="site-page-header"/>
            <NewTaskPanel subject={subject}/>
        </div>
    );
};


export default observer(TaskAdd);